import { Component } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { error } from 'jquery';
import { first } from 'rxjs';
import { Login } from 'src/app/models/login.model';
import { LoginService } from 'src/app/services/login/login.service';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css'],
})
export class LoginComponent {
  LoginForm!: FormGroup;
  lofinInfo: Login = new Login();
  submitted = false;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private authservice: LoginService,
    private formBuilder: FormBuilder
  ) {}

  loginform = true;
  recoverform = false;

  ngOnInit(): void {
    this.LoginForm = this.formBuilder.group({
      Username: ['', Validators.required],
      Password: ['', Validators.required],
    });

  }

  validateUsername() {
    this.submitted = true; // Trigger validation status
  }

  showRecoverForm() {
    this.loginform = !this.loginform;
    this.recoverform = !this.recoverform;
    this.router.navigate(['authentication/forgotpassword']);
  }

  login() {
    console.log();

    this.submitted = true;
    // stop here if form is invalid
    this.authservice
      .login(this.LoginForm.value.Username, this.LoginForm.value.Password)
      .pipe(first())
      .subscribe(
        (data) => {
          this.router.navigate(['dashboard']);
        },
        (error) => {
          const errorMessage =
          error?.error ||
          error ||
          '';
          if (errorMessage.message === 'Your password has expired.') {
            alert('Your password has expired.');
            const resetUrl = error?.error?.resetUrl;
            if (resetUrl) {
              window.location.href = resetUrl;
            }
            return;
          } else if(errorMessage === 'Your account / password combination is not matching. Please enter valid credentials.' )  {
            //alert('Something went wrong during login. Please try again later.');
            alert('You have entered an invalid username or password');
          } else {
            alert(errorMessage || 'An error occurred during login.');
          }
        }
      );
  }
  public isChecked(event: any) {
    if (event.target.checked == true) {
      localStorage.setItem('username', this.lofinInfo.username);
      localStorage.setItem('password', this.lofinInfo.password);
      localStorage.setItem('rememberMe', 'true');
    } else {
      localStorage.setItem('rememberMe', 'false');
    }
  }
}
